<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre4">Introduction</a></div>
<div class="SOM_part"><a href="#/p1">P<span class="small">RELUDE</span>: T<span class="small">HE</span> G<span class="small">ROWTH OF A</span> P<span class="small">OET’S</span> M<span class="small">IND</span></a></div>
<div class="SOM_chap"><a href="#/p1sp1chap2">1 The Kirk, the Hill, the Lighthouse Top</a></div>
<div class="SOM_chap"><a href="#/p1sp2chap2">2 Jesus and the Dragoons</a></div>
<div class="SOM_chap"><span href="#/p1sp3chap2" title="Link target outside of Sample">3 To Nether Stowey via Utopia</span></div>
<div class="SOM_chap"><span href="#/p1sp4chap2" title="Link target outside of Sample">4 A Network of Friendships</span></div>
<div class="SOM_chap"><span href="#/p1sp5chap2" title="Link target outside of Sample">5 A Visionary Landscape</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">P<span class="small">ART</span> II: T<span class="small">HE</span> M<span class="small">ARINER’S</span> T<span class="small">ALE</span></span></div>
<div class="SOM_chap"><span href="#/p2sp1chap2" title="Link target outside of Sample">6 The Ship Was Cheered</span></div>
<div class="SOM_chap"><span href="#/p2sp2chap2" title="Link target outside of Sample">7 Instead of the Cross, the Albatross</span></div>
<div class="SOM_chap"><span href="#/p2sp3chap2" title="Link target outside of Sample">8 The Night-mare Life-in-Death</span></div>
<div class="SOM_chap"><span href="#/p2sp4chap2" title="Link target outside of Sample">9 The Moving Moon</span></div>
<div class="SOM_chap"><span href="#/p2sp5chap2" title="Link target outside of Sample">10 Nine Fathom Deep</span></div>
<div class="SOM_chap"><span href="#/p2sp6chap2" title="Link target outside of Sample">11 The Two Voices</span></div>
<div class="SOM_chap"><span href="#/p2sp7chap2" title="Link target outside of Sample">12 He Prayeth Best Who Loveth Best</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Epilogue: The Morrow Morn</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample"><i>Bibliography</i></span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample"><i>Illustration Credits</i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample"><i>Index</i></span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample"><i>Studies in Theology and the Arts</i></span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample"><i>Notes</i></span></div>
<div class="SOM_appen"><span href="#/appen12" title="Link target outside of Sample">Praise for <i>Mariner</i></span></div>
<div class="SOM_appen"><span href="#/appen13" title="Link target outside of Sample"><i>About the Author</i></span></div>
<div class="SOM_appen"><span href="#/appen14" title="Link target outside of Sample"><i>More Titles from InterVarsity Press</i></span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?433a347d